import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = ["id"];
import { watchEffect, nextTick, onUnmounted } from "vue";
import * as echarts from 'echarts';
export default {
  __name: 'scatterAnalysis',
  props: {
    id: {
      type: String,
      default: 'echart'
    },
    data: {
      type: Object,
      default: function _default() {}
    }
  },
  setup: function setup(__props) {
    var props = __props;
    // const data = {
    //   title: '',
    //   legend: ['小组一', '小组二', '小组三', '小组四', '小组五', '小组六', '小组七'],
    //   series: [
    //     { name: '小组一', data: [10, 20] },
    //     { name: '小组二', data: [40, 50] },
    //     { name: '小组三', data: [20, 40] },
    //     { name: '小组四', data: [50, 10] },
    //     { name: '小组五', data: [77, 90] },
    //     { name: '小组六', data: [33, 62] },
    //     { name: '小组七', data: [11, 90] },
    //   ],
    // }
    var timer = null;
    var echartData = function echartData(data) {
      // let myChart1 = echarts.init(document.getElementById(props.id))
      var dom = document.getElementById(props.id);
      if (!dom) return;
      var myChart1 = echarts.init(dom);
      window.addEventListener('resize', function () {
        myChart1.resize();
      });
      var series = data.series.map(function (v) {
        return {
          name: v.name,
          type: 'scatter',
          data: [{
            value: v.data
          }]
        };
      });
      var option = {
        title: {
          text: data.title,
          left: 'center'
        },
        yAxis: [{
          type: 'value',
          name: '参与展示率',
          position: 'left',
          min: 0,
          max: 100,
          interval: 10,
          axisLabel: {
            formatter: '{value}%'
          }
        }],
        legend: {
          top: 0,
          left: 'center',
          data: data.legend
        },
        xAxis: {
          type: 'value',
          name: '检测正确率',
          min: 0,
          max: 100,
          interval: 5,
          splitLine: false
        },
        series: series
      };
      option && myChart1.setOption(option);
      timer = setTimeout(function () {
        myChart1.resize();
      }, 100);
    };
    watchEffect(function () {
      // console.log(props.data,84)
      if (props.data && Object.keys(props.data).length > 0) {
        nextTick(function () {
          echartData(props.data);
        });
      }
    });
    onUnmounted(function () {
      if (timer) {
        clearTimeout(timer);
      }
    });
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", {
        id: __props.id,
        style: {
          "width": "100%",
          "height": "300px"
        }
      }, null, 8, _hoisted_1);
    };
  }
};